module.exports = __webpack_public_path__ + "static/media/f_eyeshape_round_darkbrown.3e1338f4.png";